import { useQuery } from "@tanstack/react-query";
import { fetchApiGet } from "../../../utils";
import { TtStagedEvent } from "./types";

export function useListStagedEvents(guidOrderId?: string, options?: { enabled?: boolean }) {
    const params = new URLSearchParams();
    if (guidOrderId) {
        params.set("guid_order_id", guidOrderId);
    }

    return useQuery({
        queryKey: ["risk", "brokerage", "tt", "staged", guidOrderId ?? "all"],
        queryFn: () => fetchApiGet<{ staged_events: TtStagedEvent[] }>(
            "/brokerage/tt/events/staged",
            params
        ),
        enabled: options?.enabled ?? true,
    });
}

export function useGetContractPreview(eventId: string, guidOrderId: string) {
    const params = new URLSearchParams();
    params.set("event_id", eventId);
    params.set("guid_order_id", guidOrderId);

    return useQuery({
        queryKey: ["risk", "brokerage", "tt", "staged", "contract", "preview", eventId, guidOrderId],
        queryFn: () => fetchApiGet<unknown>(
            "/brokerage/tt/events/staged/contract/preview",
            params
        ),
    });
}
